import { render, staticRenderFns } from "./confirmVoteModal.vue?vue&type=template&id=53b80e7e&scoped=true&lang=html&"
import script from "./confirmVoteModal.vue?vue&type=script&lang=js&"
export * from "./confirmVoteModal.vue?vue&type=script&lang=js&"
import style0 from "./confirmVoteModal.vue?vue&type=style&index=0&id=53b80e7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b80e7e",
  null
  
)

export default component.exports